import { OrderGuide } from '@/experiences/sales-portal/domain/order-guides/blocs/types';
import { useAutosave } from '@/experiences/sales-portal/domain/order-guides/blocs/hooks/use-autosave';

interface OrderGuideAutosaveProps {
  lastSavedOrderGuide: OrderGuide;
  restaurantUUID: string;
  supplierUUID: string;
}

/**
 * Renderless container that runs the autosave loop for the open guide.
 *
 * Owns autosave as a standalone sibling so the hook is consumed once at this
 * level rather than hosted inside (and coupled to) any one sibling, keeping it
 * shared as more siblings are added.
 */
export const OrderGuideAutosaver: React.FC<OrderGuideAutosaveProps> = ({
  lastSavedOrderGuide,
  restaurantUUID,
  supplierUUID,
}) => {
  useAutosave({ lastSavedOrderGuide, restaurantUUID, supplierUUID });
  return null;
};
